export const GET_AUTO_PROMOTION_SMS_STARTED = "GET_AUTO_PROMOTION_SMS_STARTED"
export const GET_AUTO_PROMOTION_SMS_SUCCESS = "GET_AUTO_PROMOTION_SMS_SUCCESS"
export const GET_AUTO_PROMOTION_SMS_FAILURE = "GET_AUTO_PROMOTION_SMS_FAILURE"

export const UPDATE_AUTO_PROMOTION_SMS_STARTED = "UPDATE_AUTO_PROMOTION_SMS_STARTED"
export const UPDATE_AUTO_PROMOTION_SMS_SUCCESS = "UPDATE_AUTO_PROMOTION_SMS_SUCCESS"
export const UPDATE_AUTO_PROMOTION_SMS_FAILURE = "UPDATE_AUTO_PROMOTION_SMS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
